const timestamp = value => new Date(value).getTime();

const localDateKey = value => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return [date.getFullYear(), date.getMonth(), date.getDate()].join("-");
};

export function getEligibleNoteAppointments(appointments = []) {
  return appointments
    .filter(appointment => appointment?.id && appointment.status !== "cancelled")
    .filter(appointment => Number.isFinite(timestamp(appointment.date_time)))
    .sort((left, right) => timestamp(right.date_time) - timestamp(left.date_time));
}

export function selectDefaultNoteAppointment(appointments = [], now = new Date()) {
  const eligible = getEligibleNoteAppointments(appointments);
  if (eligible.length === 0) return null;

  const todayKey = localDateKey(now);
  const today = eligible.filter(appointment => localDateKey(appointment.date_time) === todayKey);
  if (today.length > 0) return today[0];

  const nowTime = now.getTime();
  const past = eligible.filter(appointment => timestamp(appointment.date_time) < nowTime);
  if (past.length > 0) return past[0];

  return [...eligible].sort((left, right) => timestamp(left.date_time) - timestamp(right.date_time))[0];
}

export function buildPatientNotesTimeline({ appointments = [], notes = [], items = null, users = [], clinics = [] }) {
  const usersById = new Map(users.map(user => [user.id, user]));
  const clinicsById = new Map(clinics.map(clinic => [clinic.id, clinic]));
  const itemsList = items || notes;
  const itemsByAppointment = new Map();

  for (const item of itemsList) {
    const appointmentId = item?.appointment_id;
    if (!appointmentId) continue;
    const existing = itemsByAppointment.get(appointmentId) || [];
    existing.push({
      ...item,
      doctorName: item.doctorName || usersById.get(item.doctor_id || item.author_id)?.name || "Unknown Doctor",
    });
    itemsByAppointment.set(appointmentId, existing);
  }

  return appointments
    .filter(appointment => itemsByAppointment.has(appointment.id))
    .sort((left, right) => timestamp(right.date_time) - timestamp(left.date_time))
    .map(appointment => {
      const sorted = itemsByAppointment
        .get(appointment.id)
        .sort((left, right) => timestamp(left.created_at) - timestamp(right.created_at));
      return {
        appointment: {
          ...appointment,
          doctorName: usersById.get(appointment.doctor_id)?.name || "Unknown Doctor",
          clinicName: appointment.clinic_id ? clinicsById.get(appointment.clinic_id)?.name || null : null,
        },
        notes: sorted,
        items: sorted,
      };
    });
}
